exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".waitlist-form .notify-text[data-v-7d06d0ad] {\n  margin-bottom: 1em;\n}\n.waitlist-form .email-input[data-v-7d06d0ad],\n.waitlist-form .submit-btn[data-v-7d06d0ad] {\n  display: inline-block;\n  vertical-align: top;\n}\n.waitlist-form .email-input[data-v-7d06d0ad] {\n  width: 65%;\n  margin-right: 0.5em;\n  margin-top: 0;\n}\n.waitlist-form .submit-btn[data-v-7d06d0ad] {\n  width: 30%;\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n  height: 44px;\n}\n", ""]);

// exports
